export const getLogoutUri = () => {
  return (
    (process.env.REACT_APP_AWS_COGNITO_LOGOUT as string) ||
    `https://pnj-tms-dev.auth.ap-southeast-1.amazoncognito.com/logout?client_id=3vq3sd0aa1dgh22crqr8isu16r&response_type=code&scope=aws.cognito.signin.user.admin+email+openid+phone+profile&redirect_uri=https://admin.tms-dev.beonetech.vn/sign-in`
  );
};
